export const CRMLeads = [
    {
      "id": 4376,
      "name": "Krishna",
      "company": "Dasari Keshava Healthcare Private Limited",
      "email": "connect@thedkverse.com",
      "phone": "9246212222",
      "value": null,
      "tags": ["Healthcare"],
      "assigned_to": ["John Doe"],
      "status": "No response",
      "source": "India Mart",
      "last_contact": "22 hrs ago",
      "created": "22 hrs ago"
    },
    {
      "id": 4375,
      "name": "Bharath Kumar",
      "company": "Allvy Software Solutions Pvt. Ltd",
      "email": "bharath.c@allvy.com",
      "phone": "7794850399",
      "value": null,
      "tags": ["Software"],
      "assigned_to": ["Jane Smith"],
      "status": "No response",
      "source": "India Mart",
      "last_contact": "1 week ago",
      "created": "1 week ago"
    },
    {
      "id": 4374,
      "name": "Pavan",
      "company": "Madhees Technologies",
      "email": "Admin@madhees.com",
      "phone": "7660000731",
      "value": null,
      "tags": ["IT"],
      "assigned_to": ["Robert White"],
      "status": "No Answer",
      "source": "Other",
      "last_contact": "2 weeks ago",
      "created": "2 weeks ago"
    },
    {
      "id": 4373,
      "name": "Darshan",
      "company": "Manchukonda Agrotech Pvt. Ltd",
      "email": "hr@manchukonda.in",
      "phone": "636312341",
      "value": null,
      "tags": ["Agriculture"],
      "assigned_to": ["Sophia Lee"],
      "status": "Follow Up",
      "source": "India Mart",
      "last_contact": "4 weeks ago",
      "created": "4 weeks ago"
    },
    {
      "id": 4372,
      "name": "Akhila V",
      "company": "Pelletronix Power Products Pvt. Ltd",
      "email": "hr@pelletronix.com",
      "phone": "9121161632",
      "value": null,
      "tags": ["Electronics"],
      "assigned_to": ["Emily Davis"],
      "status": "No response",
      "source": "Referral",
      "last_contact": "1 month ago",
      "created": "1 month ago"
    },
    {
      "id": 4371,
      "name": "Yogesh",
      "company": "PBEL City",
      "email": "yogeshk96@gmail.com",
      "phone": "8099550213",
      "value": null,
      "tags": ["Real Estate"],
      "assigned_to": ["James Martin"],
      "status": "Follow Up",
      "source": "India Mart",
      "last_contact": "1 month ago",
      "created": "1 month ago"
    },
    {
      "id": 4370,
      "name": "Rudraswamy RN",
      "company": "Toyota Material Handling India",
      "email": "rudraswamy.rn@tmhin.toyota-industries.com",
      "phone": "9743501004",
      "value": null,
      "tags": ["Automobile"],
      "assigned_to": ["Olivia Harris"],
      "status": "No Answer",
      "source": "Referral",
      "last_contact": "1 month ago",
      "created": "1 month ago"
    }
  ]
  